import { ColumnDescription } from "react-bootstrap-table-next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload, faEye, faTrash } from "@fortawesome/free-solid-svg-icons";
import Table from "../../../Table";
import { useState } from "react";
import { IComponentModal } from "../../../Modais/IModalComponent";
import ModalComponent from "../../../Modais";
import { IListarContratosCaso } from "../../../../Interfaces/Geral/Email/EmailInterface";
import { useAtendimentoPage } from "../../../../Context/AtendimentoPage";
import useAsyncEffect from "../../../../hooks/useAsyncEffect";
import {
    DesvincularContratosCasoController,
    ExportarDocumentoHtmlParaPdfController,
    ListarContratosCasoController,
} from "../../../../Controllers/Geral/Email/EmailController";
import useAsyncCallback from "../../../../hooks/useAsyncCallback";
import { saveAs } from "file-saver";
import { useHistoricoContext } from "../../../../Context/Historico";
import { Spinner } from "../../../Loding/SpinnerPadrao";
import Swal from "sweetalert2";
import moment from "moment";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

export default function DocumentosGerados() {
    const [modal, setModal] = useState<IComponentModal>();
    const [show, setShow] = useState(false);

    const { ID_CASO } = useAtendimentoPage();
    const { ReloadHistorico } = useHistoricoContext();

    const {
        value: lstContratosCaso,
        loading: lstContratosCasoLoading,
        execute: updateLstContratosCaso,
    } = useAsyncEffect(async () => {
        if (ID_CASO) {
            return ListarContratosCasoController(ID_CASO);
        }
    }, [ID_CASO]);

    const {
        execute: exportarDocumentoParaHtml,
        loading: exportarDocumentoParaHtmlLoading,
    } = useAsyncCallback(ExportarDocumentoHtmlParaPdfController);

    const {
        execute: desvincularContratosCaso,
        loading: desvincularContratosCasoLoading,
    } = useAsyncCallback(DesvincularContratosCasoController);

    const columns: Array<ColumnDescription<IListarContratosCaso>> = [
        {
            dataField: "DS_NOME_TEMPLATE",
            text: "Template Utilizado",
            align: "center",
            headerAlign: "center",
        },
        {
            dataField: "DT_CADASTRO",
            text: "Data de Geração",
            align: "center",
            headerAlign: "center",
            formatter: (cell, row) => {
                return moment(cell).format("DD/MM/YYYY HH:mm");
            },
        },
        {
            dataField: "FL_STATUS",
            text: "Status",
            align: "center",
            headerAlign: "center",
            formatter: (cell, row) => {
                return cell ? "Ativo" : "Inativo";
            },
        },
        {
            dataField: "DS_USUARIO_RESPONSAVEL",
            text: "Responsável",
            align: "center",
            headerAlign: "center",
        },
        {
            dataField: "acoes",
            text: "Ações",
            formatter: (cell, row) => (
                <div className="d-flex gap-4">
                    <OverlayTrigger
                        overlay={
                            <Tooltip id="tooltip-visualizar">
                                Visualizar
                            </Tooltip>
                        }
                    >
                        <button
                            className="btn btn-md btn-outline-info mx-2"
                            onClick={() => handleVisualizar(row)}
                        >
                            <FontAwesomeIcon icon={faEye} />
                        </button>
                    </OverlayTrigger>
                    <OverlayTrigger
                        overlay={
                            <Tooltip id="tooltip-download">Download</Tooltip>
                        }
                    >
                        <button
                            className="btn btn-md btn-outline-primary mx-2"
                            onClick={() => handleDownload(row)}
                            disabled={exportarDocumentoParaHtmlLoading}
                        >
                            {exportarDocumentoParaHtmlLoading ? (
                                <Spinner size="sm" />
                            ) : (
                                <FontAwesomeIcon icon={faDownload} />
                            )}
                        </button>
                    </OverlayTrigger>
                    <OverlayTrigger
                        overlay={
                            <Tooltip id="tooltip-excluir">Excluir</Tooltip>
                        }
                    >
                        <button
                            className="btn btn-md btn-outline-danger mx-2"
                            onClick={() => handleExcluir(row)}
                            disabled={desvincularContratosCasoLoading}
                        >
                            {desvincularContratosCasoLoading ? (
                                <Spinner size="sm" />
                            ) : (
                                <FontAwesomeIcon icon={faTrash} />
                            )}
                        </button>
                    </OverlayTrigger>
                </div>
            ),
        },
    ];

    const handleVisualizar = (row: IListarContratosCaso) => {
        setShow(true);
        setModal({
            headerComponent: `${row.DS_NOME_TEMPLATE}`,
            IconHeader: faEye,
            Component: () => (
                <div
                    style={{
                        width: "100%",
                        maxWidth: "100%",
                        overflowX: "auto",
                    }}
                    dangerouslySetInnerHTML={{
                        __html: row.DS_HTML,
                    }}
                />
            ),
            size: "xl",
        });
    };

    const handleDownload = (row: IListarContratosCaso) => {
        exportarDocumentoParaHtml(
            {
                FL_GERAR_PDF: true,
                ID_DOCUMENTO_TEMPLATE: Number(row.ID_DOCUMENTO_TEMPLATE)
                    ? Number(row.ID_DOCUMENTO_TEMPLATE)
                    : 0,
                strHTML: row.DS_HTML,
                ID_CASO: ID_CASO,
            },
            true
        ).then((res) => {
            saveAs(res, row.DS_NOME_TEMPLATE);
            ReloadHistorico();
            setShow(false);
        });
    };

    const handleExcluir = (row: IListarContratosCaso) => {
        Swal.fire({
            title: "Excluir Documento?",
            text: "Você deseja excluir o documento?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Sim",
            cancelButtonText: "Não",
        }).then((result) => {
            if (result.isConfirmed) {
                desvincularContratosCaso(
                    row.ID_CASO_DOCUMENTO_GERADO,
                    true
                ).then(() => {
                    updateLstContratosCaso();
                    ReloadHistorico();
                });
            }
        });
    };

    return (
        <div className="card card-custom card-stretch pt-5 px-4">
            <div className="d-flex justify-content-between mb-2">
                <h4 className="mb-4">Documentos Gerados</h4>
            </div>

            <Table
                keyField="ID_CASO_DOCUMENTO_GERADO"
                key={`${lstContratosCasoLoading}-${exportarDocumentoParaHtmlLoading}-${desvincularContratosCasoLoading}`}
                data={lstContratosCaso ?? []}
                columns={columns}
                noDataIndication={() => (
                    <div className="text-black-50 text-center">
                        Nenhum documento gerado
                    </div>
                )}
                bordered={false}
                loading={lstContratosCasoLoading}
                noHover
                noSearch
            />

            <ModalComponent
                ModalComponent={modal}
                setShow={setShow}
                show={show}
            />
        </div>
    );
}
